/**
 * Simple store for Admin JWT token.
 * AuthContext sets this on login/logout; API clients read it for Authorization header.
 */
let token = null;

export const setAuthToken = (t) => {
  token = t;
};

export const getAuthToken = () => token;
